import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue'
import App from 'src/App'
import Repositories from 'src/repositories'
import AppModules from 'src/modules'
import router from 'src/router'
import store from 'src/store'

import VuetifyPlugin from 'src/plugins/vuetify'
import SocketPlugin from 'src/plugins/socket'
import i18n from 'src/plugins/i18n'

import Config from 'src/config'
import manifest from '../package.json'

Repositories.registerRepository(AppModules.getRepositories())

SocketPlugin({ Vue, store })
const vuetify = VuetifyPlugin({ Vue })

Vue.config.productionTip = false
Vue.prototype.$config = Config
Vue.prototype.$manifest = {
  version: manifest.version,
  name: manifest.name,
  description: manifest.description,
  productName: manifest.productName,
}

const vue = new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')

export default vue
